<template>
  <div class="container">
    <div class="city-content">
      <div class="menu" @click="openMenu"></div>
      <!-- 品牌菜单 -->
      <!-- :list="brandList" -->

      <!--头图-->
      <div class="main-top" id="top">
        <img
          src="https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/m-banner2.png"
          class="m-banner"
          alt="头部图片"
        />
        <img
          src="https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/pc-banner2.png"
          class="pc-banner"
          alt="头部图片"
        />
        <div class="m-city-title">{{ cityName }}</div>
      </div>
      <div class="bottom-content">
        <!--底部背景-->
        <div class="pc-bg">
          <div class="left1"></div>
          <div class="left2"></div>
          <div class="right1"></div>
        </div>
        <div class="main">
          <!-- 精彩视频 -->
          <!-- v-if="videoList.length" -->
          <look-video
            v-if="videoList.length"
            :videoList="videoList"
            :isCity="true"
          ></look-video>
          <!-- 精美图赏 -->
          <enjoy-img v-if="imgList.length" :imgList="imgList"></enjoy-img>
          <!--精彩图文-->
          <related-information
            v-if="informationList.length"
            :informationList="informationList"
          ></related-information>
        </div>
      </div>
    </div>
    <div class="m-return-btn" @click="returnHome"></div>
    <div class="pc-return-btn" @click="returnHome"></div>
  </div>
</template>

<script>
import EnjoyImg from '../components/EnjoyImg'
import LookVideo from '../components/LookVideo'
import RelatedInformation from '../components/RelatedInformation'
import XHR from '../api'
export default {
  name: 'cityHome',
  components: {
    EnjoyImg,
    LookVideo,
    RelatedInformation
  },
  data: () => ({
    // 城市菜单
    isShowBrandMenu: false,
    // 视频数据
    videoList: [],
    // 图集数据
    imgList: [],
    // 文章资讯
    informationList: [],
    cityHandId: '',
    cityName: ''
  }),
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.cityHandId = to.query.id
      vm.initPartData()
    })
  },
  created () {},
  mounted () {
    this.cityName = this.$route.query.cityname
    this.cityId = this.$route.query.id
  },
  methods: {
    initPartData () {
      XHR.getHandWork({
        type: 39,
        hid: this.cityHandId
      }).then(res => {
        const { status, data } = res.data
        if (!status && data.length) {
          this.videoList = data[0].info
          this.imgList = data[1].info
          this.informationList = data[2].info
        }
      })
    },
    // 显示品牌菜单弹框
    openMenu () {
      this.$router.push({
        path: '/cityBox',
        query: { id: this.cityId, cityname: this.cityName }
      })
    },
    // 关闭品牌菜单弹框
    closeBrandMenu () {
      this.isShowBrandMenu = false
    },
    // 返回
    returnHome () {
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style lang="less" scoped>
.city-content {
  position: relative;
}
.menu {
  cursor: pointer;
  position: absolute;
  width: 45px;
  height: 35px;
  top: 27px;
  right: 27px;
  background: url(https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/city-btn.png)
    no-repeat 50% 50%;
  z-index: 200;
}
.container {
  width: 100%;
  background: #0e316b
    url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/pc-bg.png');
  background-repeat: repeat-y;
  background-size: 100%;
  padding-bottom: 50px;
}
.main-top {
  background: #0e316b;
  width: 100%;
  position: relative;
  img {
    width: 100%;
    background: #0e316b;
    position: relative;
  }
  .m-banner {
    display: block;
    height: 362px;
  }
  .pc-banner {
    display: none;
    height: 368px;
  }
  .m-city-title {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    text-align: center;
    color: #fff;
    font-size: 160px;
    line-height: 362px;
    font-weight: bold;
    // letter-spacing: 20px;
  }
}
.main-top {
  position: relative;
}
.m-return-btn {
  background-image: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/m-return.png');
  width: 98px;
  height: 100px;
  position: fixed;
  right: 20px;
  bottom: 20%;
  z-index: 1005;
  cursor: pointer;
}
.pc-return-btn {
  background-image: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/pc-return.png');
  width: 168px;
  height: 70px;
  position: fixed;
  right: 20px;
  bottom: 20%;
  z-index: 1000;
  display: none;
  cursor: pointer;
}
@media screen and (min-width: 751px) {
  .pc-return-btn {
    display: block;
  }
  .m-return-btn {
    display: none;
  }
  .main-top {
    .pc-banner {
      display: block;
    }
    .m-banner {
      display: none;
    }
  }
  .bottom-content {
    position: relative;
  }
  .main {
    width: 750px;
    margin: 0 auto;
  }
  .pc-bg {
    display: block;
    background: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/pc-bg.png');
  }
}
/deep/.ele-title {
  width: 100%;
  text-align: center;
  margin: 60px auto 40px;
}
</style>
